export const environment = {
  production: true,
  citizensApi: 'https://back.umrah.eg/api',
  citizensBaseUrl:'https://back.umrah.eg/'
};
